import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import moment from 'moment';
import Spinner from '~/components/spinner/spinner';
import LotStatusIcon from '~/components/lotStatusIcon/lotStatusIcon';
import LotStatusText from '~/components/lotStatusText/lotStatusText';
import FilterInput from '~/components/filterInput/filterInput';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import styles from './styles.css';

export const getConsolidatedLotsQuery = gql`
  query lots($breweryId: Int!, $isConsolidated: Boolean) {
    lots(breweryId: $breweryId, isConsolidated: $isConsolidated) {
      id
      reference
      startDate
      currentVolume
      volume
      status
      product {
        id
        name
      }
      nextTransfer {
        id
        transferDate
        name
        type
        tankType
        tank {
          id
          name
        }
      }
    }
  }
`;

export class ConsolidatedLotsList extends Component {
  state = {
    filteredLots: [],
    filterText: ''
  };

  onFilterChange = (event, lots) => {
    const { value } = event.target;
    if (!value.length) {
      return this.setState({
        filteredLots: [],
        filterText: ''
      });
    }
    const filterValue = value.toLowerCase();

    const filteredLots = lots.filter(lot => {
      return (
        lot.reference.toLowerCase().indexOf(filterValue) !== -1 ||
        lot.product.name.toLowerCase().indexOf(filterValue) !== -1 ||
        lot.status
          .replace('_', ' ')
          .toLowerCase()
          .indexOf(filterValue) !== -1
      );
    });

    return this.setState({
      filterText: value,
      filteredLots
    });
  };

  renderNextTransferDate = lot => {
    const { nextTransfer } = lot;
    if (!nextTransfer) {
      return '--';
    }

    const transferDate = moment(nextTransfer.transferDate);
    let extraInfoFragment = null;

    if (transferDate.startOf('d') === moment().startOf('d')) {
      extraInfoFragment = <span className={`db ${styles.dueToday}`}>(due today)</span>;
    } else if (transferDate.toDate() < new Date()) {
      extraInfoFragment = <span className={`db ${styles.overdue}`}>(overdue)</span>;
    }

    return (
      <Fragment>
        {extraInfoFragment}
        <span className="db strong">
          {nextTransfer.name}
          {nextTransfer.type === 'TANK' &&
            ['BRITE_TANK', 'UNI_TANK'].indexOf(nextTransfer.tankType) !== -1 &&
            nextTransfer.tank && <em> - {nextTransfer.tank.name}</em>}
        </span>

        <span className="db">{transferDate.format('dddd Do MMMM')}</span>
      </Fragment>
    );
  };

  render() {
    const { brewery, history } = this.props;
    return (
      <Query
        query={getConsolidatedLotsQuery}
        variables={{ breweryId: brewery.id, isConsolidated: true }}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { filterText, filteredLots } = this.state;
          const lots = filterText.length ? filteredLots : data.lots;

          return (
            <Fragment>
              <URLParamBanner addWord="scheduled" name="lot" />
              <Card className="content">
                <div className="flex pa3 w-100">
                  <FilterInput onChange={e => this.onFilterChange(e, data.lots)} className="flex-grow-1" />
                </div>
                <div>
                  <header className="flex ttu table-header pv2">
                    <div className="w-5 tc" />
                    <div className="w-15">Status</div>
                    <div className="w-10">Ref #</div>
                    <div className="w-20">Product</div>
                    <div className="w-20">Start date</div>
                    <div className="w-20">Next transfer</div>
                    <div className="w-10">Volume</div>
                  </header>
                  <div>
                    {lots.map(lot => (
                      <div
                        className="flex pointer pv3 bt-divider row-hover items-center"
                        key={lot.id}
                        onClick={() => {
                          history.push(`/lots/${lot.id}`);
                        }}
                      >
                        <div className="w-5 pl2 pr2 tc" />
                        <div className="w-15 pr2 flex items-center">
                          <LotStatusIcon className="mr2" status={lot.status} />
                          <LotStatusText capitalise status={lot.status} />
                        </div>

                        <div className="w-10 pr2">
                          <strong>{lot.reference}</strong>
                        </div>
                        <div className="w-20 pr2">{lot.product.name}</div>
                        <div className="w-20 pr2">{moment(lot.startDate).format('dddd Do MMMM')}</div>
                        <div className="w-20 pr2">{lot.status !== 'COMPLETED' && this.renderNextTransferDate(lot)}</div>
                        <div className="w-10">{lot.currentVolume}L</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(ConsolidatedLotsList));



// WEBPACK FOOTER //
// ./src/containers/consolidatedLotList/consolidatedLotList.jsx